import type { PublicRuntimeConfig } from 'nuxt/schema'

export default function (environment: PublicRuntimeConfig['environment']) {
  return useRuntimeConfig().public.environment === environment
}
